import { render } from "./Event.vue?vue&type=template&id=51ebf2eb"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"
script.render = render

export default script